import React from 'react';
import D_Number from '@utils/number';
import { Tooltip as AntTooltip } from 'antd';

const Tooltip = (props) => (
  <AntTooltip
    getPopupContainer={() =>
      document.getElementById('top-squares-anchor') || document.body
    }
    {...props}
    placement="bottom"
  >
    {props.children}
  </AntTooltip>
);

const buildTooltip = (countryNames) => {
  const len = countryNames.length;
  if (len === 0) {
    return 'None';
  }
  return (
    <div>
      {countryNames.map((countryName, i) => {
        if (len === i + 1) {
          return countryName;
        }
        return `${countryName}, `;
      })}
    </div>
  );
};

const EmployeeHeadcountInfo = ({ data = {} }) => {
  const { financial, dun } = data;
  return (
    <div className="subsidiaries-employee-headcount">
      <div className="title-text part-title">Employee Headcount</div>
      <div className="headcount-item sub-info-text">
        <span>Financial Statement</span>
        <span className="headcount-number">
          {addDefaultPlaceholder(D_Number.addSeparator(financial))}
        </span>
      </div>
      <div className="headcount-item sub-info-text">
        <span>Dun & Bradstreet</span>
        <span className="headcount-number">
          {addDefaultPlaceholder(D_Number.addSeparator(dun))}
        </span>
      </div>
    </div>
  );
};

const addDefaultPlaceholder = (str) => str || '-';

const buildExpandPresence = ({
  presence,
  subsidiaries,
  branches,
  countryNames,
  officeCountryAmount,
  officesAmount,
  officeCountryNames,
}) => (
  <div className="a-info-card">
    <div className="presence-info-wrapper">
      <div className="part-title">LE Presence</div>
      <div className="expand-square-wrapper">
        <div className="expand-presence">
          <div>
            {addDefaultPlaceholder(D_Number.addSeparator(presence))}
            <Tooltip
              placement="right"
              title={buildTooltip(countryNames)}
              overlayClassName={
                countryNames?.length
                  ? 'le-info-tooltip le-info-tooltip-arrow-fix adjust-tooltip-index'
                  : 'le-info-tooltip-arrow-fix adjust-tooltip-index'
              }
            >
              <span className="appkiticon icon-information-fill" />
            </Tooltip>
          </div>
          <div className="sub-info-text">Countries</div>
        </div>
        <div className="expand-presence">
          <div className="color-ac">
            {addDefaultPlaceholder(D_Number.addSeparator(branches))}
          </div>
          <div className="sub-info-text">Branches</div>
        </div>
        <div className="expand-presence">
          <div className="color-ac">
            {addDefaultPlaceholder(D_Number.addSeparator(subsidiaries))}
          </div>
          <div className="sub-info-text">Subsidiaries</div>
        </div>
      </div>
    </div>
    <div className="presence-divide-line" />
    <div className="office-info-wrapper">
      <div className="part-title">Office Location</div>
      <div className="expand-square-wrapper">
        <div className="expand-presence">
          <div>
            {addDefaultPlaceholder(D_Number.addSeparator(officeCountryAmount))}
            <Tooltip
              placement="right"
              title={buildTooltip(officeCountryNames)}
              overlayClassName={
                officeCountryNames?.length
                  ? 'le-info-tooltip le-info-tooltip-arrow-fix adjust-tooltip-index'
                  : 'le-info-tooltip-arrow-fix adjust-tooltip-index'
              }
            >
              <span className="appkiticon icon-information-fill" />
            </Tooltip>
          </div>
          <div className="sub-info-text">Countries</div>
        </div>
        <div className="expand-presence">
          <div className="color-ac">
            {addDefaultPlaceholder(D_Number.addSeparator(officesAmount))}
          </div>
          <div className="sub-info-text">Offices</div>
        </div>
      </div>
    </div>
  </div>
);

const filterEmptyValue = (array = []) =>
  array.filter((i) => i !== null && i !== undefined);

const InfoCards = ({
  expand,
  buyerLabel,
  buyerBranches,
  buyerPresence,
  buyerOfficeCount,
  buyerCountryNames,
  buyerSubsidiaries,
  buyerOfficeCountryCount,
  buyerOfficeCountryNames,
  targetLabel,
  targetBranches,
  targetPresence,
  targetOfficeCount,
  targetCountryNames,
  targetSubsidiaries,
  targetOfficeCountryCount,
  targetOfficeCountryNames,
  sharedPresence,
  sharedCountryNames,
  sharedOfficeCountryCount,
  sharedOfficeCountryNames,
  displayItem = 'Presence',
  headcount,
}) => {
  if (expand) {
    return (
      <div className="top-squares">
        <div className="side-label">{`${buyerLabel}`}</div>
        <div className="compare-square buyer">
          {buildExpandPresence({
            presence: buyerPresence,
            subsidiaries: buyerSubsidiaries,
            branches: buyerBranches,
            countryNames: filterEmptyValue(buyerCountryNames),
            officeCountryAmount: buyerOfficeCountryCount,
            officesAmount: buyerOfficeCount,
            officeCountryNames: filterEmptyValue(buyerOfficeCountryNames),
          })}
          <EmployeeHeadcountInfo data={headcount?.buyer} />
        </div>
        <div className="side-label">{targetLabel}</div>
        <div className="compare-square target">
          {buildExpandPresence({
            presence: targetPresence,
            subsidiaries: targetSubsidiaries,
            branches: targetBranches,
            countryNames: filterEmptyValue(targetCountryNames),
            officeCountryAmount: targetOfficeCountryCount,
            officesAmount: targetOfficeCount,
            officeCountryNames: filterEmptyValue(targetOfficeCountryNames),
          })}
          <EmployeeHeadcountInfo data={headcount?.target} />
        </div>
        <div className="side-label">Shared</div>
        <div className="compare-square shared">
          <div className="presence-info-wrapper">
            <div className="part-title">LE Presence</div>

            <div>
              {addDefaultPlaceholder(D_Number.addSeparator(sharedPresence))}
              <Tooltip
                placement="right"
                title={buildTooltip(filterEmptyValue(sharedCountryNames))}
                overlayClassName={
                  filterEmptyValue(sharedCountryNames)?.length
                    ? 'le-info-tooltip le-info-tooltip-arrow-fix adjust-tooltip-index'
                    : 'le-info-tooltip-arrow-fix adjust-tooltip-index'
                }
              >
                <span className="appkiticon icon-information-fill" />
              </Tooltip>
            </div>
            <div className="sub-info-text">Countries</div>
          </div>
          <div className="presence-divide-line" />
          <div className="office-info-wrapper">
            <div className="part-title">Office Location</div>
            <div>
              {addDefaultPlaceholder(
                D_Number.addSeparator(sharedOfficeCountryCount),
              )}
              <Tooltip
                placement="right"
                title={buildTooltip(filterEmptyValue(sharedOfficeCountryNames))}
                overlayClassName={
                  filterEmptyValue(sharedOfficeCountryNames)?.length
                    ? 'le-info-tooltip le-info-tooltip-arrow-fix adjust-tooltip-index'
                    : 'le-info-tooltip-arrow-fix adjust-tooltip-index'
                }
              >
                <span className="appkiticon icon-information-fill" />
              </Tooltip>
            </div>
            <div className="sub-info-text">Countries</div>
          </div>
        </div>
      </div>
    );
  }

  let buyerAmount,
    targetAmount,
    sharedAmount,
    buyerCountryNamesToShow,
    targetCountryNamesToShow,
    sharedCountryNamesToShow;
  if (displayItem === 'Presence') {
    buyerAmount = buyerPresence;
    targetAmount = targetPresence;
    sharedAmount = sharedPresence;
    buyerCountryNamesToShow = filterEmptyValue(buyerCountryNames);
    targetCountryNamesToShow = filterEmptyValue(targetCountryNames);
    sharedCountryNamesToShow = filterEmptyValue(sharedCountryNames);
  } else {
    buyerAmount = buyerOfficeCountryCount;
    targetAmount = targetOfficeCountryCount;
    sharedAmount = sharedOfficeCountryCount;
    buyerCountryNamesToShow = filterEmptyValue(buyerOfficeCountryNames);
    targetCountryNamesToShow = filterEmptyValue(targetOfficeCountryNames);
    sharedCountryNamesToShow = filterEmptyValue(sharedOfficeCountryNames);
  }

  return (
    <div className="top-squares" id="top-squares-anchor">
      <div className="compare-square buyer">
        <div>{`${buyerLabel} ${displayItem}`}</div>
        <>
          <div>
            {addDefaultPlaceholder(D_Number.addSeparator(buyerAmount))}
            <Tooltip
              placement="right"
              title={buildTooltip(buyerCountryNamesToShow)}
              overlayClassName={
                buyerCountryNamesToShow?.length
                  ? 'le-info-tooltip le-info-tooltip-arrow-fix adjust-tooltip-index'
                  : 'le-info-tooltip-arrow-fix adjust-tooltip-index'
              }
            >
              <span className="appkiticon icon-information-fill" />
            </Tooltip>
          </div>
          <div className="sub-info-text">Countries</div>
        </>
      </div>
      <div className="compare-square target">
        <div>
          {targetLabel} {displayItem}
        </div>
        <>
          <div>
            {addDefaultPlaceholder(D_Number.addSeparator(targetAmount))}
            <Tooltip
              placement="right"
              title={buildTooltip(targetCountryNamesToShow)}
              overlayClassName={
                targetCountryNamesToShow?.length
                  ? 'le-info-tooltip le-info-tooltip-arrow-fix adjust-tooltip-index'
                  : 'le-info-tooltip-arrow-fix adjust-tooltip-index'
              }
              // visible={true}
            >
              <span className="appkiticon icon-information-fill" />
            </Tooltip>
          </div>
          <div className="sub-info-text">Countries</div>
        </>
      </div>
      <div className="compare-square shared">
        <div>Shared {displayItem}</div>
        <div>
          {addDefaultPlaceholder(D_Number.addSeparator(sharedAmount))}
          <Tooltip
            placement="right"
            title={buildTooltip(sharedCountryNamesToShow)}
            overlayClassName={
              sharedCountryNamesToShow?.length
                ? 'le-info-tooltip le-info-tooltip-arrow-fix adjust-tooltip-index'
                : 'le-info-tooltip-arrow-fix adjust-tooltip-index'
            }
          >
            <span className="appkiticon icon-information-fill" />
          </Tooltip>
        </div>
        <div className="sub-info-text">Countries</div>
      </div>
    </div>
  );
};

export default InfoCards;
